import { eventChannel, END } from 'redux-saga';

export const SOCKET_CHANNEL_EVENTS = {
    CONNECT:           'connect',
    DISCONNECT:        'disconnect',
    CONNECT_ERROR:     'connect_error',
    RECONNECT_ATTEMPT: 'reconnect_attempt',
    RECONNECT:         'reconnect',
    RECONNECT_FAILED:  'reconnect_failed',
    SESSION_EXPIRED:   'session_expired',
};

/**
 * Creates a redux-saga eventChannel that emits frames for every relevant
 * socket event. The saga consumer receives { event, data } frames.
 *
 * customEvents is an array of additional string event names the caller
 * wants forwarded (e.g. 'notification:invite', 'presence:joined').
 */
export function createSocketChannel(socket, customEvents = []) {
    return eventChannel((emit) => {
        const builtIn = Object.values(SOCKET_CHANNEL_EVENTS);
        const allEvents = [...builtIn, ...customEvents];

        const handlers = {};
        for (const eventName of allEvents) {
            const handler = (data) => emit({ event: eventName, data });
            handlers[eventName] = handler;
            socket.on(eventName, handler);
        }

        // Unsubscribe when the channel is closed.
        return () => {
            for (const eventName of allEvents) {
                socket.off(eventName, handlers[eventName]);
            }
            emit(END);
        };
    });
}
